import React, { Component } from 'react';
import Auth from './';
const auth = new Auth();

export default ChildComponent => {
  class ComposedComponent extends Component {
    // Our component just got rendered
    componentDidMount() {
      this.shouldNavigateAway();
    }

    // Our component just got updated
    componentDidUpdate() {
      this.shouldNavigateAway();
    }

    shouldNavigateAway() {
      if (!auth.isAuthenticated()) {
        this.props.history.push('/prihlaseni');
      }
    }

    render() {
      return <ChildComponent {...this.props} />;
    }
  }

  /* function mapStateToProps(state) {
    return { auth: state.auth.authenticated };
  }

  return connect(mapStateToProps)(ComposedComponent);
}; */

  return ComposedComponent;
};



// WEBPACK FOOTER //
// ./src/services/auth/requireAuth.js